<template>
  <el-popover
      :content="status"
      placement="top-start"
      title="Status"
      trigger="hover"
      width="200">
    <div slot="reference">
      <span class="text-info" v-if="status == 'On Progress'">
      {{ status }} <i class="el-icon-loading"></i>
    </span>
      <span class="text-success" v-else-if="status == 'Completed'">
      {{ status }}
    </span>
    <span class="text-danger" v-else>
      {{ status }}
    </span>
    </div>
  </el-popover>
</template>

<script>


export default {
  data() {
    return {
      status: null,
      isOnProgress: false,
      id: null,
      tried: 0,
      timeOutHandler: null
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeOutHandler)
  },
  beforeMount() {
    this.id = this.params.data.id
    this.setStatus(this.params.data.status)
  },
  methods: {
    ...$mapActions('voip-vendor-api', {getRateDocumentStatus: 'getRateDocumentStatus'}),
    setStatus(status) {
      this.status = status
      this.isOnProgress = this.status == 'On Progress'
      if (this.isOnProgress) {
        this.timeOutHandler = setTimeout(() => {
          this.refreshStatus()
        }, 5000)
      }
    },
    refreshStatus() {
      if (this.tried < 8) {
        this.tried += 1
        this.getRateDocumentStatus(this.id).then((r) => {
          this.setStatus(r)
        })
      }
    }
  }
}
</script>
